import type { UiKey } from '@/i18n/dictionary';
import type { PaywallIntent } from './PaywallContext';

/**
 * Заголовок окна оплаты по причине входа: окно называет то, во что человек упёрся.
 * Тексты — строки реестра утверждений маркетинга (`shotbook-marketing/messaging/claims.md`
 * :52, :53, :54). Вход без своей строки — общий заголовок `paywall.title`. Шаринг доски
 * (`canvas_share`) — тоже общий: строка реестра о шаринге называет приглашения, а рядом с ними
 * обязательна строка о присутствии (:56) — в заголовок окна она не помещается; причину входа
 * окно уже называет строкой причины.
 * Меняется только текст: кнопки, план по умолчанию и события окна те же.
 */
export function paywallHeadlineKey(intent: Pick<PaywallIntent, 'source' | 'reason'>): UiKey {
  const { source, reason } = intent;
  if (
    reason === 'detail_quota' ||
    source === 'detail_quota' ||
    source === 'quota_badge' ||
    source === 'quota_last_view'
  )
    return 'paywall.headline.detailViews';
  if (source === 'show_more' || source === 'free_banner') return 'paywall.headline.search';
  if (reason === 'canvas_limit' || source === 'canvas_limit') return 'paywall.headline.boards';
  return 'paywall.title';
}
